import {createStore, applyMiddleware, compose, combineReducers} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

/**  Reducers **/
import appModalReducer from "./reducers/appModalReducer";

const appReducer = combineReducers({
    modal: appModalReducer,
});


const middlewares = [thunk];
const middlewareEnhancer = applyMiddleware(...middlewares);
const enhancers = [middlewareEnhancer];
const composedEnhancers = process.env.NODE_ENV === 'development' ? composeWithDevTools(...enhancers) : compose(...enhancers);



export default function makeStore(){
    return createStore(appReducer, undefined, composedEnhancers);
};



